import { create } from 'zustand';

export interface ToastItem {
  id: number;
  kind: 'success' | 'error' | 'info';
  message: string;
}

interface UiState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebar: (collapsed: boolean) => void;
  /** Tenant activo para navegación; persiste en localStorage. */
  activeTenantId: string | null;
  setActiveTenant: (id: string | null) => void;
  /** Toast queue (in-house, sin react-hot-toast). */
  toasts: ToastItem[];
  pushToast: (kind: ToastItem['kind'], message: string) => void;
  dismissToast: (id: number) => void;
}

const ACTIVE_TENANT_KEY = 'zen_admin_active_tenant';

function loadActiveTenant(): string | null {
  try {
    return typeof localStorage !== 'undefined'
      ? localStorage.getItem(ACTIVE_TENANT_KEY)
      : null;
  } catch {
    return null;
  }
}

function persistActiveTenant(id: string | null): void {
  try {
    if (typeof localStorage === 'undefined') return;
    if (id) localStorage.setItem(ACTIVE_TENANT_KEY, id);
    else localStorage.removeItem(ACTIVE_TENANT_KEY);
  } catch {
    /* ignore quota / disabled storage */
  }
}

let toastSeq = 1;

export const useUiStore = create<UiState>((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebar: (collapsed) => set({ sidebarCollapsed: collapsed }),
  activeTenantId: loadActiveTenant(),
  setActiveTenant: (id) => {
    persistActiveTenant(id);
    set({ activeTenantId: id });
  },
  toasts: [],
  pushToast: (kind, message) => {
    const id = toastSeq++;
    set((s) => ({ toasts: [...s.toasts, { id, kind, message }] }));
    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
      }, 4000);
    }
  },
  dismissToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
